import type { SchemaOwner } from '@cli-types/preset-engine/presets.js'
import { loadSchemaOwnershipIndex } from './load-schema-ownership-index.js'

export function getSchemaOwner(cwd: string, schemaName: string): SchemaOwner | undefined {
  return loadSchemaOwnershipIndex(cwd).schemas[schemaName]
}
